export interface ArtistModel {
  id: string;
  name: string;
}
